// Commitment priority pill — FE-041.

import type { CommitmentPriority } from "./types";


// Outlined treatment to match the Pencil ``BeneCRM Tasks`` frame:
// a transparent fill with a subtle stroke + small dot accent reads
// quieter than the FE-041 fill style and stops the priority pill
// from competing with the status badge for attention. High keeps
// the ember accent so it still pops.
const META: Record<
  CommitmentPriority,
  { label: string; classes: string; dot: string }
> = {
  high:   {
    label: "High",
    classes: "border border-ember/40 bg-ember-tint/40 text-ember",
    dot: "bg-ember",
  },
  medium: {
    label: "Medium",
    classes: "border border-border-subtle bg-transparent text-text-primary",
    dot: "bg-text-secondary",
  },
  low:    {
    label: "Low",
    classes: "border border-border-subtle bg-transparent text-text-tertiary",
    dot: "bg-text-tertiary",
  },
};


export function CommitmentPriorityBadge({
  priority,
}: { priority: CommitmentPriority }) {
  const meta = META[priority];
  return (
    <span
      data-testid={`commitment-priority-${priority}`}
      data-priority={priority}
      className={[
        "inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium",
        meta.classes,
      ].join(" ")}
    >
      <span
        aria-hidden="true"
        className={[
          "inline-block h-1.5 w-1.5 rounded-full",
          meta.dot,
        ].join(" ")}
      />
      {meta.label}
    </span>
  );
}
